import React, { useEffect } from "react";
import "../assets/css/boothList.css";
import { BoothCard } from "../components/booths";
import { useDispatch, useSelector } from "react-redux";
import { getBooths } from "../reducks/booths/selectors";
import { fetchBooths } from "../reducks/booths/operations";
import { HeaderMenu } from "../components/header";
import { hideLoadingAction, showLoadingAction } from "../reducks/loading/actions";
import FooterBox from "../components/footer/FooterBox";

const BoothList = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const booths = getBooths(selector);

  useEffect(() => {
    dispatch(showLoadingAction());
    dispatch(fetchBooths());
    dispatch(hideLoadingAction());
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <section className="common-container center">
        <div className="common-container__header--inner center-box">
          <HeaderMenu />
          <div className="spacer-box--m" />
          {booths.length !== 0 ? (
            <div className="grid__row">
              {booths.map((booth) => (
                <div key={booth.id}>
                  {booth.release.state !== false ? (
                    <div>
                      <BoothCard
                        id={booth.id}
                        selectOpuses={booth.selectOpuses}
                        boothName={booth.boothName}
                        organizerName={booth.organizerName}
                        isBlack={booth.isBlack}
                        isGothic={booth.isGothic}
                        liveDay={booth.liveDay}
                        liveTime={booth.liveTime}
                      />

                      <div className="spacer-box--l"></div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div>まだ登録がありません</div>
          )}
        </div>
      </section>
      <FooterBox />
    </>
  );
};

export default BoothList;
